const NUMBER_MUST_BE_NUMBER_STRING = 'number must be a number string';
const USER_ROLE_NOT_SUPPORTED = 'USER_ROLE_NOT_SUPPORTED';

const normalizeMessages = (message) => {
  if (Array.isArray(message)) return message;
  if (message) return [message];

  return [];
};

export const getAddPlaceErrorMessage = ({ error, t }) => {
  if (!error?.response) {
    return t('api.network-error');
  }

  const requestId = error?.config?.headers?.['request-id'];
  const status = error?.response?.status;
  const responseErrorCode = error?.response?.data?.error;
  const responseMessage = error?.response?.data?.message;
  const responseMessages = normalizeMessages(responseMessage);

  if (responseErrorCode === USER_ROLE_NOT_SUPPORTED) {
    return t('structures-view.place-manager-role-error');
  }

  if (
    status === 400 &&
    responseMessages.includes(NUMBER_MUST_BE_NUMBER_STRING)
  ) {
    return `${t('api.bad-parameters-error', {
      requestId,
    })}: ${t('api.validation-number-string')}`;
  }

  if (status === 400) {
    return t('api.bad-parameters-error', { requestId });
  }

  return t('api.general-error', { requestId });
};
